import {LoopType} from "../../player/models/parameters/LoopParameters";

export type HandType = 'LEFT' | 'RIGHT';
export type PlayableType = 'version' | 'part' | 'section' | 'bloc' | 'challenge' | 'list'

export function playableTypeFromLoopType(loopType: LoopType): PlayableType {
  switch (loopType) {
    case "PLAY":
      return 'version'
    case "PART":
      return 'part'
    case "SECTION":
      return 'section'
    case "RHYTHMIC_BLOC":
      return 'bloc'
    case "LIST":
      return 'list'
    case "NONE":
      console.error('no playable type for loopType ' + loopType);
      return 'version'
  }
}
export function loopTypeFromPlayableType(playableType: PlayableType): LoopType {
  switch (playableType) {
    case "version":
    case "challenge":
      return 'PLAY'
    case "part":
      return 'PART'
    case "section":
      return 'SECTION'
    case "bloc":
      return 'RHYTHMIC_BLOC'
    case "list":
      return 'LIST'
  }
}
